import ReactGA from "react-ga4";
import { errorHandler } from "./Api";
import { ANALYTIC_EVENT_ACTIONS, ANALYTIC_EVENT_CATEGORIES, JSON_TABLE_INPUT_TYPE } from "./Constants";

export const trackEvent = (category, action, label = "") => {
    ReactGA.event({ category, action, label });
};

export const trackFormData = (formConfig, formData) => {
    try {
        const formTrackingId = formConfig?.trackingKey || "";
        if (formTrackingId) {
            trackEvent(ANALYTIC_EVENT_CATEGORIES.FORM, `${ANALYTIC_EVENT_ACTIONS.SUBMIT_FORM}`, formTrackingId)
        }

        const fields = formConfig.sections.flatMap((s) => {
            return s.fields.flat().filter(f => f.trackValue)
        })

        if (fields.length) {
            const formatedField = fields.map(f => {
                if (f.type === JSON_TABLE_INPUT_TYPE) {
                    const structureAtributes = Object.keys(f.dataSchema).reduce((a, v) => {
                        const fv = f.dataSchema[v];
                        if (fv.trackValue) {
                            return [
                                ...a,
                                {
                                    ...fv,
                                    name: v
                                }
                            ]
                        } return a;
                    }, [])
                    const values = JSON.parse(formData[f.name])
                    return f.legend + " -  " + structureAtributes.map(v => {
                        const atributeData = values.map(sv => sv[v.name]).join(" , ");
                        return `${v.label} = [ ${atributeData} ] `
                    }).join(" , ")
                } else {
                    return `${f.label} - ${formData[f.name]}`
                }
            })

            formatedField.forEach(f => {
                const formTrackingId = formConfig?.trackingKey || "";
                trackEvent(ANALYTIC_EVENT_CATEGORIES.FORM, `${ANALYTIC_EVENT_ACTIONS.SUBMIT_FORM} - ${formTrackingId}`, f)
            })
        }

    } catch (err) {
        errorHandler("Unable to submit Event to Analytic", err)
    }

}